import env from "../env";

export const transformFeeOptions = (feeOptions, chargedProductIds = []) => {
  const HANDLING_FEE_THRESHOLD = env.HANDLING_FEE_THRESHOLD;
  const HANDLING_FEE_UPSELL_ID = env.HANDLING_FEE_UPSELL_ID;

  return feeOptions.map((option) => {
    const isChargedById = chargedProductIds.includes(option.value);
    const exceedsThreshold = HANDLING_FEE_UPSELL_ID && option.price >= HANDLING_FEE_THRESHOLD;

    let displayText = option.text;
    if (exceedsThreshold) {
      displayText = `${option.text} + Handling Fee`;
    }

    return {
      ...option,
      text: displayText,
      disabled: isChargedById,
    };
  });
};
